import React from 'react';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { noOptionsMessage, loadingMessage } from './utils';

class SearchableSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: this.props.defaultValue
    };
  }

  isDifferentOptions(currentOptions, prevOptions) {
    if (currentOptions.length !== prevOptions.length) {
      return true;
    }

    for (let i = 0; i < currentOptions.length; i++) {
      if (
        currentOptions[i].value !== prevOptions[i].value ||
        currentOptions[i].label !== prevOptions[i].label
      ) {
        return true;
      }
    }
    return false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.isDisabled && !prevProps.isDisabled) {
      this.setState({
        selectedOption: null
      });
    } else if (this.isDifferentOptions(this.props.options, prevProps.options)) {
      this.setState({
        selectedOption: null
      });
    }
  }

  handleChange = selectedOption => {
    this.setState({
      selectedOption: selectedOption
    });
    if (this.props.actionOnSelectedOption) {
      this.props.actionOnSelectedOption(selectedOption.value);
    }
  };

  render() {
    const { classes, options, placeholder, isDisabled, inputId } = this.props;

    return (
      <div className={classes.root}>
        <Select
          inputId={inputId}
          isDisabled={isDisabled}
          classes={classes}
          options={options}
          value={this.state.selectedOption}
          onChange={this.handleChange}
          placeholder={placeholder}
          noOptionsMessage={noOptionsMessage}
          loadingMessage={loadingMessage}
        />
      </div>
    );
  }
}

export default withStyles(styles)(SearchableSelect);
